// extracted by mini-css-extract-plugin
export default {"tableItemColorContainer":"table_tableItemColorContainer__a9+WO"};